import { render, staticRenderFns } from "./termos.vue?vue&type=template&id=3f232fe1"
import script from "./termos.vue?vue&type=script&lang=js"
export * from "./termos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports